import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Environment } from '../../../environments/environment.interface';
import { NodeEnv } from '../enums/node-env.enum';
import {
  AppInfo,
  ApiConfig,
  RealtimeConfig,
  DevConfig,
} from '../config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: Environment = environment;

  /**
   * Application metadata and core configuration
   */
  get app(): AppInfo {
    return {
      name: 'Blink',
      version: this.config.version,
      environment: this.config.environment,
      nodeEnv: this.config.nodeEnv,
      muiKey: this.config.muiKey,
    };
  }

  /**
   * API and backend service configuration
   */
  get api(): ApiConfig {
    return {
      host: this.config.apiHost,
      baseHost: this.config.baseHost,
      qrHost: this.config.qrHost,
      staticHost: this.config.staticHost,
      tenant: {
        default: this.config.defaultTenant,
        available: this.config.tenants,
      },
    };
  }

  /**
   * Real-time communication configuration
   */
  get realtime(): RealtimeConfig {
    return {
      broadcaster: this.config.broadcaster as 'pusher' | 'laravel',
      pusher: {
        appId: this.config.pusherAppID,
        key: this.config.pusherKey,
        secret: this.config.pusherSecret,
        cluster: this.config.pusherCluster,
        scheme: this.config.pusherScheme,
        port: this.config.pusherPort,
      },
      echo: {
        host: this.config.echoHost,
      },
      reverb: {
        appId: this.config.reverbAppId,
        host: this.config.reverbHost,
        appKey: this.config.reverbAppKey,
      },
    };
  }

  /**
   * Development-only configuration
   */
  get dev(): DevConfig {
    return {
      reactDevServerUrl: this.config.reactDevServerUrl,
    };
  }

  get isProduction(): boolean {
    return this.config.nodeEnv === NodeEnv.Production;
  }

  get isDevelopment(): boolean {
    return this.config.nodeEnv === NodeEnv.Development;
  }

  get nodeEnv(): NodeEnv {
    return this.config.nodeEnv;
  }
}
